(function($) {
    $(document).ready(function() {

        /*
        // trigger resize event after 3s to counter JS issues on live    
        setTimeout(function() {
            $(window).trigger('resize');
          }, 3000);
        
        // yacht form resize
        $("a.fancybox-trigger").click(function(e) {            
            setTimeout(function() {
                $(window).trigger('resize'); 
            }, 500);
        })

        Fancybox.bind('.fancybox-trigger', {
            fullscreen: {
              autoStart: true,
            },
          }); 
        */       

        //Smooth scroll
        $("a[href^='#']").click(function(e) {
            e.preventDefault();
            let offset = 0;
    
            if($(".sticky-header") > 0) {
                offset += $(".sticky-header").outerHeight();
            }
            
            if($(".page-navigation").length > 0) {
                offset += $(".page-navigation").outerHeight();
            }
            
            var position = $($(this).attr("href")).offset().top;
            
            $("body, html").animate({
                scrollTop: position - offset
            }, 1500 );
        });



        $(".to-top").click(function(e) {
            e.preventDefault();

            $("body, html").animate({
                scrollTop: 0
            }, 1500 );
        })


        $(".range-dropdown").on("click", function() {
            $("body").toggleClass("expand-nav");

            if(!$("body").hasClass("expand-nav")) {
                $('.hamburger').addClass("collapse");
                $('.hamburger').removeClass("expand");
            }
            else {
                $('.hamburger').addClass("expand");
                $('.hamburger').removeClass("collapse");
            }
        });

        $(".range-navigation__menu .menu-item-has-children > a").on('click', function(e) {
            e.preventDefault();
            $(this).parent().toggleClass('menu-expand');
        })

        rangeNavigationSetPreview($(".range-navigation__range-item-actual.active"));

        $(".range-navigation__range-item-actual").on("mouseenter", function() {
            let $_this = $(this);

            $(".range-navigation__range-item-actual").each(function() {
                if(!$(this).is($_this)) {
                    $(this).removeClass('active');
                }
                else {
                    $(this).addClass('active');
                    rangeNavigationSetPreview($(this));
                }
            })
        });
    
        toggleStickyHeader();

        $(window).on('scroll', function() {
            toggleStickyHeader();
        });

        function toggleStickyHeader() {
            if($(window).scrollTop() > 150) {
                $(".sticky-header").addClass('show');
            }
            else {
                $(".sticky-header").removeClass('show');
            }
        }

        $('.sistership-btn').on("click", function() {
            $('.sistership-btn').removeClass('active');
            $(this).addClass('active');
            $(".sistership").css('display', 'none');
            $(".sistership[data-tab=" + $(this).attr('data-target') + "]").css('display', 'block').find('.sistership-slider').slick('setPosition').next().slick('setPosition');
        });

        try {
            FWP.refresh();
        }
        catch(e) {
        }
    });

    function rangeNavigationSetPreview($element) {
        $('.range-navigation__preview').attr('src', $element.attr('data-thumbnail'));
    }

})(jQuery);